<template>
    <div v-if="fullData">
        <form-wizard
            color="rgba(var(--vs-primary), 1)"
            :title="null"
            :subtitle="null"
            @on-complete="onComplete(fullData)"
            :nextButtonText="$t('next')"
            :backButtonText="$t('back')"
            :finishButtonText="$t('finish')"
        >
            <tab-content
                class="mb-5"
                :before-change="
                    (param) => getStatusValidation(param, 'past_education')
                "
            >
                <PastEducation
                    :data="fullData"
                    :disabled="!fullData['changes_allowed']"
                    @setNewDataInObject="setNewDataInObject"
                    :file_upload_limitation="file_upload_limitation"
                    ref="past_education"
                />
            </tab-content>
            <tab-content
                class="mb-5"
                :before-change="
                    (param) => getStatusValidation(param, 'certificate_of_test')
                "
            >
                <CertificateOfTestENTAndKT
                    :data="fullData"
                    :disabled="!fullData['changes_allowed']"
                    @setNewDataInObject="setNewDataInObject"
                    :file_upload_limitation="file_upload_limitation"
                    ref="certificate_of_test"
                />
            </tab-content>
            <tab-content
                class="mb-5"
                :before-change="
                    (param) =>
                        getStatusValidation(param, 'international_certificates')
                "
                v-if="fullData['international_certificate_allowed']"
            >
                <InternationalCertificates
                    :data="fullData"
                    :disabled="!fullData['changes_allowed']"
                    @setNewDataInObject="setNewDataInObject"
                    :file_upload_limitation="file_upload_limitation"
                    ref="international_certificates"
                />
            </tab-content>
            <tab-content
                class="mb-5"
                :before-change="(param) => getStatusValidation(param, 'grants')"
            >
                <Grants
                    :data="fullData"
                    :disabled="!fullData['changes_allowed']"
                    @setNewDataInObject="setNewDataInObject"
                    :file_upload_limitation="file_upload_limitation"
                    ref="grants"
                />
            </tab-content>
            <tab-content
                class="mb-5"
                :before-change="
                    (param) =>
                        getStatusValidation(param, 'direction_of_training')
                "
            >
                <DirectionOfTraining
                    :data="fullData"
                    :disabled="!fullData['changes_allowed']"
                    @setNewDataInObject="setNewDataInObject"
                    :file_upload_limitation="file_upload_limitation"
                    ref="direction_of_training"
                />
            </tab-content>
        </form-wizard>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FormWizard, TabContent, WizardStep } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import PastEducation from "@/pages/Home/FillingInTheApplicantsData/Declaration/modules/PastEducation";
import CertificateOfTestENTAndKT from "@/pages/Home/FillingInTheApplicantsData/Declaration/modules/CertificateOfTestENTAndKT";
import InternationalCertificates from "@/pages/Home/FillingInTheApplicantsData/Declaration/modules/InternationalCertificates";
import Grants from "@/pages/Home/FillingInTheApplicantsData/Declaration/modules/Grants";
import DirectionOfTraining from "@/pages/Home/FillingInTheApplicantsData/Declaration/modules/DirectionOfTraining";

export default {
    name: "Page",
    components: {
        FormWizard,
        TabContent,
        WizardStep,
        PastEducation,
        CertificateOfTestENTAndKT,
        InternationalCertificates,
        Grants,
        DirectionOfTraining,
    },
    data() {
        return {
            fullData: null,
            file_upload_limitation: null,
        };
    },
    computed: {
        ...mapGetters({
            user: "user/getUser",
        }),
    },
    methods: {
        async getFullData() {
            this.$vs.loading();
            try {
                const response = await this.$http.get(
                    "admissions/applicants/data/",
                    {
                        params: {
                            profile: this.user.profileId,
                        },
                    }
                );

                this.fullData = response.data;
            } catch (e) {}
            this.$vs.loading.close();
        },
        async getFileUploadLimitation() {
            try {
                this.file_upload_limitation = (
                    await this.$http.get("common/settings/")
                ).data[0];
            } catch (e) {
            } finally {
            }
        },
        async getStatusValidation(param, name) {
            // Проверяю, срендерен ли компонент, чтобы провести валидацию, либо просто не пропускаю на след. шаг
            if (Object.keys(this.$refs).length > 0) {
                return await this.$refs[name].validateStep();
            } else {
                return false;
            }
        },
        setNewDataInObject({ name, data }) {
            this.fullData[name] = data;
        },
        onComplete(object) {
            if (!object["is_ready"]["documents"]) {
                this.$router.push({ name: "additional-documents-applicant" });
            } else if (!object["is_ready"]["form"]) {
                this.$router.push({ name: "questionnaire-applicant" });
            } else {
                this.$router.push({ name: "filling-applicant-data" });
            }
        },
    },
    created() {
        this.getFullData();
        this.getFileUploadLimitation();
    },
};
</script>

<style scoped lang="scss">
</style>
